import {Select} from '@management-ui/core';
import React from 'react';

const CurrencySelect = ({name = 'currency', prefix, label = 'Currency'}) => (
  <Select
    name={name}
    prefix={prefix}
    label={label}
    options={[{title: 'GBP', value: 'GBP'}, {title: 'EUR', value: 'EUR'}]}
  />
);

export default CurrencySelect;
